"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.greetings = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.greetings = (0, basic_1.applyBase)(Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.M), { mb: [3, 0], px: [2, 0], '.name': {
        pl: 2,
    } }));
//# sourceMappingURL=greetings.js.map